module.exports = __webpack_public_path__ + "static/arthur-lung-particles-4cf2d731c5c402d0ea20875673747d42.mp4";